import React from 'react';
import { SpecNav } from '../components/spec/SpecNav';
import { SpecHero } from '../components/spec/SpecHero';
import { LayersSection } from '../components/spec/LayersSection';
import { PresenceSection } from '../components/spec/PresenceSection';
import { MotionSection } from '../components/spec/MotionSection';
import { AtmosphereSection } from '../components/spec/AtmosphereSection';
import { RulesSection } from '../components/spec/RulesSection';
import { ComponentsSection } from '../components/spec/ComponentsSection';
const sections = [{
  id: 'lagen',
  label: 'Twee lagen'
}, {
  id: 'aanwezigheid',
  label: 'Aanwezigheid'
}, {
  id: 'beweging',
  label: 'Beweging'
}, {
  id: 'sfeer',
  label: 'Sfeer'
}, {
  id: 'regels',
  label: 'Vaste regels'
}, {
  id: 'componenten',
  label: 'Componenten'
}];
export function SpecStyle() {
  return <div className="min-h-screen w-full bg-night-950 font-sans text-ink" data-id="element-1948" data-mp="1a3fx5vzoo5bb">
      <SpecNav sections={sections} data-id="element-1949" data-mp="155ecj6mlzxxq" />
      <main data-id="element-1950" data-mp="15436t19lsg3z">
        <SpecHero data-id="element-1951" data-mp="3z03tqvxwov4" />
        <div className="mx-auto max-w-[1440px] px-6 lg:px-12" data-id="element-1952" data-mp="3zicjmzsgvjx">
          <LayersSection data-id="element-1953" data-mp="3x5vdc1uup7x" />
          <PresenceSection data-id="element-1954" data-mp="8xthbjb88fva" />
          <MotionSection data-id="element-1955" data-mp="8x1qsmwhl8bv" />
          <AtmosphereSection data-id="element-1956" data-mp="8w8ru83rrn4a" />
          <RulesSection data-id="element-1957" data-mp="dotjp4347q56" />
          <ComponentsSection data-id="element-1958" data-mp="dojq76iv30uq" />
        </div>
      </main>
      <footer className="border-t border-white/[0.06] py-10" data-id="element-1959" data-mp="dr5wl2u0nabd">
        <p className="mx-auto max-w-[1440px] px-6 text-[13px] text-ink-muted lg:px-12" data-id="element-1960" data-mp="iml9nsk7926q">
          Anna · Spec &amp; Stijl v2 · Wandtablet en commandocentrum zijn gebouwd.
        </p>
      </footer>
    </div>;
}